export var SearchMaskActionTypes;
(function (SearchMaskActionTypes) {
    SearchMaskActionTypes["SEARCH_MASK_ACTIVE_TAB_CHANGE"] = "SEARCH_MASK_ACTIVE_TAB_CHANGE";
    SearchMaskActionTypes["RESET_SEARCH_MASK_TO_DEFAULT_STATE"] = "RESET_SEARCH_MASK_TO_DEFAULT_STATE";
    SearchMaskActionTypes["SET_SEARCH_MASK_CONFIRMED_STATE"] = "SET_SEARCH_MASK_CONFIRMED_STATE";
    SearchMaskActionTypes["SEARCH_MASK_BUNDLE_INIT"] = "SEARCH_MASK_BUNDLE_INIT";
    SearchMaskActionTypes["SEARCH_MASK_MODAL_INIT"] = "SEARCH_MASK_MODAL_INIT";
    SearchMaskActionTypes["CLOSE_CALENDAR"] = "CLOSE_CALENDAR";
    SearchMaskActionTypes["CHANGE_CALENDAR_INIT_FLOW"] = "CHANGE_CALENDAR_INIT_FLOW";
    SearchMaskActionTypes["CHANGE_ACTIVE_DATE"] = "CHANGE_ACTIVE_DATE";
    SearchMaskActionTypes["CHANGE_DURATION_UI"] = "CHANGE_DURATION_UI";
    SearchMaskActionTypes["CHANGE_EXACT_DURATION"] = "CHANGE_EXACT_DURATION";
    SearchMaskActionTypes["CHANGE_CALENDAR_UI"] = "CHANGE_CALENDAR_UI";
    SearchMaskActionTypes["CHANGE_SHOW_ERROR_TRAVELLERS"] = "CHANGE_SHOW_ERROR_TRAVELLERS";
    SearchMaskActionTypes["SET_PAGINATION"] = "SET_PAGINATION";
})(SearchMaskActionTypes || (SearchMaskActionTypes = {}));
